module.exports = __webpack_public_path__ + "img/symbol_1.42c0cc36.png";